<template>
  <form
    :action="formAction"
    @submit.prevent
    method="post"
    ref="loginForm"
  >
    <slot name="csrf-token"/>
    <slot name="input-next"/>

    <div class="form-row">
      <div class="form-group col">
        <label
          :class="{ 'error-anchor': emailError }"
        >
          {{ i18n.email }}
        </label>
        <input
          name="email"
          type="email"
          v-model.trim="email"
          :class="['form-control',
                  {'is-invalid' : emailError }]"
          :placeholder="i18n.email"
        >
        <div
          v-if="emailError"
          class="invalid-feedback"
        >
          {{ emailError }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label class="control-label">
          {{ i18n.password }}
        </label>
        <input
          name="password"
          v-model.trim="password"
          :type="isPasswordVisible ? 'text': 'password'"
          :class="['form-control',
                  {'is-invalid error-anchor' : passwordError}]"
          :placeholder="i18n.password"
        >
        <span
          @click="onEyeClick"
          :class="['fa fa-fw field-icon toggle-password',
                   isPasswordVisible ? 'fa-eye' : 'fa-eye-slash']"
          aria-hidden="true"/>
        <div
          v-if="passwordError"
          class="invalid-feedback"
        >
          {{ passwordError }}
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col">

        <turnstile
          v-if="showTurnstile"
          :class="{'border-error error-anchor': !isRecaptchaFilled}"
          :sitekey="newCaptchaSiteKey"
          :language="language">
        </turnstile>

        <hcaptcha
          v-else-if="showHcaptcha"
          :class="{'border-error error-anchor' : (recaptchaError||!isRecaptchaFilled)}"
          :sitekey="newCaptchaSiteKey"
          :language="language">
        </hcaptcha>

        <recaptcha
          v-else
          :class="{'border-error error-anchor': (recaptchaError||!isRecaptchaFilled)}"
          :sitekey="recaptchaPublicKey"
          :language="language">
        </recaptcha>
        <div
          v-if="recaptchaError"
          class="invalid-feedback"
        >
          {{ recaptchaError }}
        </div>
      </div>
    </div>

    <ui-alert
      v-if="generalError"
      type="error"
      :title="generalError"
      class="mb-4"></ui-alert>

    <ui-button
      @click="validate"
      block
      uppercase
      appearance="primary"
      :disabled="!isRecaptchaReady || submittedForm"
      :label="i18n.login">
    </ui-button>
  </form>

</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import Turnstile from './turnstile';
import {mapGetters} from "vuex";
import {isValidEmail} from "../services/email_validator";

export default {
  props: {
    'initEmail': {
      type: String,
      require: true
    },
    'initEmailError': {
      type: String,
      require: true
    },
    'initPassword': {
      type: String,
      require: true
    },
    'initPasswordError': {
      type: String,
      require: true
    },
    'initRecaptchaError': {
      type: String,
      require: true
    },
    'initGeneralError': {
      type: String,
      require: true
    },
    'formAction': {
      type: String,
      require: true
    },
    'newCaptchaSiteKey': {
      type: String,
      require: true
    },
    'language': {
      type: String,
      require: true
    },
    'recaptchaPublicKey': {
      type: String,
      require: true
    },
    'showTurnstile': {
      type: Boolean,
      require: true
    },
    'showHcaptcha': {
      type: Boolean,
      require: true
    },
  },

  components: {
    Recaptcha,
    Hcaptcha,
    Turnstile,
    UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ './ui/ui-button.vue'),
  },

  data() {
    return {
      isPasswordVisible: false,
      email: this.initEmail?.trim(),
      emailError: this.initEmailError,
      password: this.initPassword?.trim(),
      passwordError: this.initPasswordError,
      recaptchaError: this.initRecaptchaError,
      generalError: this.initGeneralError,
      isRecaptchaFilled: true,
      submittedForm: false,
      i18n: {
        email: gettext('Email'),
        password: gettext('Password'),
        login: gettext('Login'),
      }
    };
  },

  computed: {
    ...mapGetters({
      isRecaptchaReady: 'ui/recaptcha/isReady',
      recaptchaResponse: 'ui/recaptcha/response',
    }),
  },

  methods: {
    onEyeClick() {
      this.isPasswordVisible = !this.isPasswordVisible
    },
    validate(event) {
      this.emailError = '';
      this.passwordError = '';
      this.recaptchaError = '';
      this.isRecaptchaFilled = !!this.recaptchaResponse;

      if (isValidEmail(this.email) && this.password && this.isRecaptchaFilled) {
        this.submittedForm = true;
        this.$refs.loginForm.submit();
        return true;
      } else {
        if (!this.email) {
          this.emailError = gettext('Please fill in this field')
        } else if (!isValidEmail(this.email)) {
          this.emailError = gettext('This is not a valid email');
        }
        if (!this.password) {
          this.passwordError = gettext('Please fill in this field')
        }
        if (!this.isRecaptchaFilled) this.recaptchaError = gettext('Please fill in this field');

      }

      // go to the first error after dom updates
      this.$nextTick().then(() => {
        this.$skokka.scrollToError();
      });
    },
  },
};

</script>
